import { Accordion, BoxSkeleton, SkeletonLoader } from '@europrocurement/flexy-components';
import { BillingInfo } from '@europrocurement/l2d-modules';
import { AddressChoice } from '@europrocurement/l2d-modules/modules/Dossiers/components/detail/SelectBillingAddress/SelectBillingAddress';
import { Card, PaletteColor, useTheme } from '@mui/material';
import * as React from 'react';

type BillingAddressSectionProps = {
    prescriberId: number;
    recipientId: number;
    prescriberLabel: string;
    prescriberSiren: string;
    prescriberAddress: string;
    handleRecipientChange: (recipientId?: number | undefined) => void;
    clientAddresses: AddressChoice[];
    billingType: number;
    handleBillingTypeChange: (billingType?: number | undefined) => void;
    canEdit: boolean;
    isLoading: boolean;
};

const BillingAddressSection: React.FunctionComponent<BillingAddressSectionProps> = function ({
    prescriberId,
    recipientId,
    prescriberLabel,
    prescriberSiren,
    prescriberAddress,
    handleRecipientChange,
    clientAddresses,
    billingType,
    handleBillingTypeChange,
    canEdit,
    isLoading,
}: BillingAddressSectionProps) {
    const { palette } = useTheme();
    return (
        <Card
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                boxShadow: 'none',
                padding: 0,
            }}
            id="adresseDeFacturation"
        >
            <Accordion
                sx={{
                    boxShadow: 'none',
                }}
                title="Adresse de facturation"
                titlesSx={{
                    fontWeight: '600',
                    boxShadow: 'none',
                }}
                headerSx={{ boxShadow: 'none' }}
                expanded
                expandColor={palette.text.primary as unknown as PaletteColor}
            >
                <SkeletonLoader
                    isLoading={isLoading}
                    skeleton={
                        <BoxSkeleton
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'start',
                                width: '100%',
                                height: '180px',
                            }}
                        />
                    }
                >
                    <BillingInfo
                        prescriberId={prescriberId}
                        recipientId={recipientId}
                        prescriberLabel={prescriberLabel}
                        prescriberSiren={prescriberSiren}
                        prescriberAddress={prescriberAddress}
                        onRecipientChange={handleRecipientChange}
                        addresses={clientAddresses}
                        billingType={billingType}
                        onBillingTypeChange={handleBillingTypeChange}
                        canEdit={canEdit}
                    />
                </SkeletonLoader>
            </Accordion>
        </Card>
    );
};

export default BillingAddressSection;
